"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderSpinner = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const spinner_icon_1 = require("../icons/spinner-icon");
const styled_1 = require("./styled");
const LoaderSpinner = (props) => {
    const { label } = props;
    return (react_1.default.createElement(styled_1.StyledLoaderWrapper, { className: "loader-spinner-wrapper" },
        react_1.default.createElement(spinner_icon_1.SpinnerIcon, null),
        react_1.default.createElement(styled_1.TextWrapper, { className: "text-wrapper" },
            react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy200, tag: components_core_1.TextTag.span }, label ? label : 'Loading...'))));
};
exports.LoaderSpinner = LoaderSpinner;
